<template>
  <v-navigation-drawer
    v-if="!hideSideMenuFromCurrentRoute"
    :value="isMenuOpen"
    app
    mobile-breakpoint="0"
    clipped
    :expand-on-hover="!isMobile"
    class="side-menu"
    width="300"
    :right="isMobile"
    :permanent="!isMobile"
    :temporary="isMobile"
    @input="(value) => $emit('update:isMenuOpen', value)"
  >
    <v-list nav class="side-menu-margin-bottom">
      <div v-if="isMobile">
        <v-list-item two-line>
          <v-list-item-avatar>
            <v-avatar color="marca-0-l10" size="45" style="color: white">{{ $getLoggedUser().name && $getLoggedUser().name.charAt(0) }}</v-avatar>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ userName }}</v-list-item-title>
            <v-list-item-subtitle>{{ this.$getLoggedUser().client }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
      </div>

      <v-list-item v-if="$permissions.havePagePermission('home')" to="/home">
        <v-list-item-icon>
          <mf-icon fill>home</mf-icon>
        </v-list-item-icon>
        <v-list-item-content class="body-2 d-flex flex-row align-center">Home</v-list-item-content>
      </v-list-item>

      <div v-if="!onlyMercapromo && $permissions.haveParentPermission('empresa')">
        <side-menu-maintenance-item v-if="isInMaintenance('empresa')" icon="work" text="Empresa" />

        <v-list-group v-else group="empresa" no-action>
          <template v-slot:activator>
            <v-list-item-icon>
              <mf-icon fill>work</mf-icon>
            </v-list-item-icon>
            <v-list-item-content id="sidemenu-empresa" class="px-0">
              <v-list-item-title class="body-2 d-flex flex-row align-center">
                Empresa
                <news-badge v-if="verifyNewsModule('Empresa')" variant="text" class="ml-1" />
              </v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item
            v-if="$permissions.havePagePermission('empresa/faturamento_incremental') && $getAllowedModules()['offer_management']"
            to="/empresa/faturamento-incremental"
            data-userflow-id="faturamento-incremental"
          >
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Faturamento incremental </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="$permissions.havePagePermission('empresa/decomposicao')" to="/empresa/decomposicao">
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Decomposição de faturamento </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="$permissions.havePagePermission('empresa/faturamento')" to="/empresa/faturamento">
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Faturamento </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="$permissions.havePagePermission('empresa/desempenho')" to="/empresa/desempenho">
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Desempenho </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </div>

      <div v-if="!onlyMercapromo && $permissions.haveParentPermission('clube')">
        <side-menu-maintenance-item v-if="isInMaintenance('clube')" icon="favorite" text="Clube" />

        <v-list-group v-else group="clube" no-action>
          <template v-slot:activator>
            <v-list-item-icon>
              <mf-icon fill>favorite</mf-icon>
            </v-list-item-icon>
            <v-list-item-content class="px-0">
              <v-list-item-title class="body-2 d-flex flex-row align-center">
                Clube
                <news-badge v-if="verifyNewsModule('Clube')" variant="text" class="ml-1" />
              </v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-if="$permissions.havePagePermission('clube/dashboard')" to="/clube/dashboard">
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Dashboard </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="$permissions.havePagePermission('clube/desempenho')" to="/clube/desempenho">
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Desempenho </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="$permissions.havePagePermission('clube/comparativo')" to="/clube/comparativo">
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Comparativo </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="$permissions.havePagePermission('clube/lojas')" to="/clube/lojas">
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Lojas </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="
              $hasPiiEmployeesAccess() && $permissions.havePagePermission('clube/performance_operacional') && $getAllowedModules()['operational_performance']
            "
            to="/clube/performance-operacional"
          >
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Performance operacional </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </div>

      <div v-if="!onlyMercapromo && $permissions.havePagePermission('maria/quando-vou-vender')">
        <side-menu-maintenance-item v-if="isInMaintenance('maria')" maria text="mar.ia" />

        <v-list-group v-else group="maria" no-action>
          <template v-slot:activator>
            <v-list-item-icon>
              <img :src="require('@/assets/icons/mar.ia-cor.svg')" alt="maria" />
            </v-list-item-icon>
            <v-list-item-content class="px-0">
              <v-list-item-title class="body-2 d-flex flex-row align-center" data-userflow-id="menu-maria">
                mar.ia
                <news-badge v-if="verifyNewsModule('Mar.ia')" variant="text" class="ml-1" />
              </v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item to="/maria/quando-vou-vender" data-userflow-id="quando-vou-vender">
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Previsão de vendas clube </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="$permissions.havePagePermission('maria/campanha-da-maria')" to="/maria/campanha-da-maria" data-userflow-id="campanha-da-maria">
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Campanha da mar.ia </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            v-if="$permissions.havePagePermission('maria/produtos-impulsionadores')"
            to="/maria/produtos-impulsionadores"
            data-userflow-id="produtos-impulsionadores"
          >
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Produtos impulsionadores </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </div>

      <div v-if="$permissions.haveParentPermission('industria') && $getAllowedModules()['industry']">
        <side-menu-maintenance-item v-if="isInMaintenance('industria')" icon="currency_exchange" text="Indústria" />

        <v-list-group v-else group="industria" no-action>
          <template v-slot:activator>
            <v-list-item-icon>
              <mf-icon fill :show-notification="availableTradeOffers.showNotification">currency_exchange</mf-icon>
            </v-list-item-icon>
            <v-list-item-content class="px-0">
              <v-list-item-title class="body-2 d-flex flex-row align-center">
                Indústria
                <news-badge v-if="verifyNewsModule('Indústria')" variant="text" class="ml-1" />
              </v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item to="/industria/resultados-gerais">
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Resultados gerais </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="$permissions.havePagePermission('industria/ofertas_trade')" to="/industria/ofertas-trade">
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Ofertas de trade </v-list-item-title>
            </v-list-item-content>
            <mf-notifications-badge
              v-if="availableTradeOffers.showNotification"
              :notifications-counter="availableTradeOffers.notificationsCounter"
              size="medium"
            />
          </v-list-item>

          <v-list-item v-if="$permissions.havePagePermission('industria/sms_trade')" to="/industria/sms-trade">
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> SMS de trade </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="$permissions.havePagePermission('industria/cashback_trade')" to="/industria/cashback-trade" data-userflow-id="cashback-trade">
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Cashback de trade </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </div>

      <div v-if="$permissions.haveParentPermission('clientes') && clientMenuItems.length > 0">
        <side-menu-maintenance-item v-if="isInMaintenance('clientes')" icon="group" text="Clientes" />

        <v-list-group v-else group="clientes" no-action>
          <template v-slot:activator>
            <v-list-item-icon>
              <mf-icon fill :show-notification="pendingOptoutRequests.showNotification">group</mf-icon>
            </v-list-item-icon>
            <v-list-item-content class="px-0">
              <v-list-item-title class="body-2 d-flex flex-row align-center">
                Clientes
                <news-badge v-if="verifyNewsModule('Clientes')" variant="text" class="ml-1" />
              </v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="clientMenuItem in clientMenuItems"
            :key="clientMenuItem.to"
            :to="clientMenuItem.to"
            :data-userflow-id="clientMenuItem.dataUserflowId"
          >
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> {{ clientMenuItem.text }} </v-list-item-title>
            </v-list-item-content>
            <mf-notifications-badge v-if="clientMenuItem.showNotification" :notifications-counter="clientMenuItem.notificationsCounter" size="medium" />
          </v-list-item>
        </v-list-group>
      </div>

      <div v-if="$permissions.haveParentPermission('produtos')">
        <side-menu-maintenance-item v-if="isInMaintenance('produtos')" icon="sell" text="Produtos" />

        <v-list-group v-else group="produtos" no-action>
          <template v-slot:activator>
            <v-list-item-icon>
              <mf-icon fill>sell</mf-icon>
            </v-list-item-icon>
            <v-list-item-content class="px-0">
              <v-list-item-title class="body-2 d-flex flex-row align-center">
                Produtos
                <news-badge v-if="verifyNewsModule('Produtos')" variant="text" class="ml-1" />
              </v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-if="$permissions.havePagePermission('produtos/busca_produto')" to="/produtos/busca-produto">
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Busca de produto </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="$permissions.havePagePermission('produtos/ranking_produtos')" to="/produtos/ranking-produtos">
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Ranking de produtos </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="$permissions.havePagePermission('produtos/arvore_produtos') && $getAllowedModules()['products_tree'] && !isFranchise"
            to="/produtos/arvore-produtos"
          >
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Árvore de produtos </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="$permissions.havePagePermission('produtos/comparativo_produtos')" to="/produtos/comparativo-produtos">
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Comparativo de produtos </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="!isFranchise && $permissions.havePagePermission('produtos/comparativo_categorias') && $getAllowedModules()['products_tree']"
            to="/produtos/comparativo-categorias"
          >
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Comparativo de categorias </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="$permissions.havePagePermission('produtos/gerenciamento_produtos')" to="/produtos/gerenciamento-produtos">
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Gerenciamento de produtos </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="$permissions.havePagePermission('produtos/faixas_precos')" to="/produtos/faixas-precos">
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Faixas de preços </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </div>

      <div v-if="!onlyMercapromo && $permissions.haveParentPermission('mobile') && $getAllowedModules()['mobile']">
        <side-menu-maintenance-item v-if="isInMaintenance('mobile')" icon="smartphone" text="Aplicativo" />

        <v-list-group v-else group="mobile" no-action>
          <template v-slot:activator>
            <v-list-item-icon>
              <mf-icon fill>smartphone</mf-icon>
            </v-list-item-icon>
            <v-list-item-content class="px-0">
              <v-list-item-title class="body-2 d-flex flex-row align-center">
                Aplicativo
                <news-badge v-if="verifyNewsModule('Aplicativo')" variant="text" class="ml-1" />
              </v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item v-if="$permissions.havePagePermission('mobile/destaques')" to="/mobile/destaques" data-userflow-id="destaques-app">
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Destaques </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="$permissions.havePagePermission('mobile/desempenho') && $getAllowedModules()['mobile']" to="/mobile/desempenho">
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Desempenho </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="$permissions.havePagePermission('mobile/banners') && $getAllowedModules()['mobile']" to="/mobile/banners">
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Banners </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="haveMobileOffersTabsPermission && $getAllowedModules()['mobile']" to="/mobile/ofertas">
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Ofertas do aplicativo </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="$permissions.havePagePermission('mobile/pontos') && $getAllowedModules()['mobile'] && $getAllowedModules()['points'] && !isFranchisee"
            data-userflow-id="pontos"
            to="/mobile/pontos"
          >
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Pontos </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="haveMobileCashbackTabsPermission && $getAllowedModules()['cashback']" to="/mobile/cashback">
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Cashback </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="$permissions.havePagePermission('mobile/encartes') && ($getAllowedModules()['mobile'] || $getAllowedModules()['chatbot'])"
            to="/mobile/encartes"
          >
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Encartes </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!-- <v-list-item v-if="$permissions.havePagePermission('mobile/chatbot') && $getAllowedModules()['chatbot']" to="/mobile/chatbot">
              <v-list-item-content>
                <v-list-item-title class="body-2">Chatbot</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->
          <v-list-item v-if="$permissions.havePagePermission('mobile/sorteio') && $getAllowedModules()['raffle']" to="/mobile/sorteios">
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Sorteios </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </div>

      <v-divider v-if="!onlyMercapromo && $permissions.haveParentPermission('campanhas')" />

      <div v-if="!onlyMercapromo && $permissions.haveParentPermission('campanhas')">
        <side-menu-maintenance-item v-if="isInMaintenance('campanhas')" icon="flash_on" text="Campanhas" />

        <v-list-group v-else group="campanhas" no-action>
          <template v-slot:activator>
            <v-list-item-icon>
              <mf-icon fill>flash_on</mf-icon>
            </v-list-item-icon>
            <v-list-item-content class="px-0">
              <v-list-item-title class="body-2 d-flex flex-row align-center">
                Campanhas
                <news-badge v-if="verifyNewsModule('Campanhas')" variant="text" class="ml-1" />
              </v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-if="$permissions.havePagePermission('campanhas/calendario_promocional')" to="/campanhas/calendario-promocional">
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Calendário promocional </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="$permissions.havePagePermission('campanhas/resultados_gerais')" to="/campanhas/resultados-gerais">
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Resultados gerais </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="$permissions.havePagePermission('campanhas/gestao_ofertas/ofertas') && $getAllowedModules()['offer_management']"
            to="/campanhas/gestao-ofertas"
          >
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Gestão de ofertas </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="$permissions.havePagePermission('campanhas/whatsapp') && $getAllowedModules()['whatsapp']" to="/campanhas/whatsapp">
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> WhatsApp </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="$permissions.havePagePermission('campanhas/sms')" to="/campanhas/sms">
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> SMS </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="$permissions.havePagePermission('campanhas/aplicativo') && $getAllowedModules()['push']" to="/campanhas/aplicativo">
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Aplicativo </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="$permissions.havePagePermission('campanhas/resultados_encarte')" to="/campanhas/resultados-encarte">
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Resultados de encarte </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="$permissions.havePagePermission('campanhas/email-v2') && $getAllowedModules()['email_v2']" to="/campanhas/email">
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> E-mail </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-if="$permissions.havePagePermission('campanhas/cupom_desconto') && $getAllowedModules()['discount_coupon']"
            to="/campanhas/cupom-desconto"
          >
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> Cupom de desconto </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </div>

      <v-list-item v-if="showHub" to="/gerenciador-analises">
        <v-list-item-icon>
          <mf-icon fill>article</mf-icon>
        </v-list-item-icon>
        <v-list-item-content class="body-2 d-flex flex-row align-center">Gerenciador de análises</v-list-item-content>
      </v-list-item>

      <div v-if="!onlyMercapromo && $permissions.haveParentPermission('configuracoes') && configMenuItems.length > 0">
        <side-menu-maintenance-item v-if="isInMaintenance('configuracoes')" icon="settings" text="Configurações" />

        <v-list-group v-else group="configuracoes" no-action>
          <template v-slot:activator>
            <v-list-item-icon>
              <mf-icon fill>settings</mf-icon>
            </v-list-item-icon>
            <v-list-item-content class="px-0">
              <v-list-item-title class="body-2 d-flex flex-row align-center">
                Configurações
                <news-badge v-if="verifyNewsModule('Configurações')" variant="text" class="ml-1" />
              </v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="configMenuItem in configMenuItems"
            :key="configMenuItem.to"
            :to="configMenuItem.to"
            :data-userflow-id="configMenuItem.dataUserflowId"
          >
            <v-list-item-content>
              <v-list-item-title class="body-2 d-flex flex-row align-center"> {{ configMenuItem.text }} </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </div>

      <v-list-item v-if="isMobile" @click="logout">
        <v-list-item-icon>
          <v-icon color="red">logout</v-icon>
        </v-list-item-icon>
        <v-list-item-content class="px-0">
          <v-list-item-title class="body-2 d-flex flex-row align-center"> Sair </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { verifyNewsModule, isNew } from '@/helpers/news.js'
import { mapGetters } from 'vuex'
import NewsBadge from './NewsBadge.vue'
import SideMenuMaintenanceItem from './SideMenuMaintenanceItem.vue'
import { formattedRedirectLogout } from '@/helpers/login'
export default {
  components: { SideMenuMaintenanceItem, NewsBadge },
  props: {
    isMenuOpen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['maintenanceModules', 'maintenanceAccountIds', 'platformNotifications']),
    availableTradeOffers() {
      return {
        showNotification:
          Boolean(this.platformNotifications?.AVAILABLE_TRADE_OFFERS?.entities_amount) && this.$permissions.havePagePermission('industria/ofertas_trade'),
        notificationsCounter: this.platformNotifications?.AVAILABLE_TRADE_OFFERS?.entities_amount ?? 0,
      }
    },
    shouldShowGerenciamentoMenuItem() {
      return !this.onlyMercapromo && this.hasPiiAccess && this.haveManagementTabsPermission
    },
    pendingOptoutRequests() {
      if (!this.shouldShowGerenciamentoMenuItem) {
        return {
          showNotification: false,
          notificationsCounter: 0,
        }
      }
      return {
        showNotification: Boolean(this.platformNotifications?.PENDING_USER_DELETE_DATA_REQUESTS?.entities_amount),
        notificationsCounter: this.platformNotifications?.PENDING_USER_DELETE_DATA_REQUESTS?.entities_amount ?? 0,
      }
    },
    hideSideMenuFromCurrentRoute() {
      const routeNamesToHide = ['Sorteador']
      return routeNamesToHide.includes(this.$route?.name)
    },
    isFranchise() {
      return this.$getLoggedUser().is_franchise
    },
    isFranchisee() {
      return this.$getLoggedUser().is_franchisee
    },
    onlyMercapromo() {
      return this.$getLoggedUser().only_mercapromo
    },
    haveInterestTabsPermission() {
      return (
        this.$permissions.havePagePermission('clientes/interesses/genero') ||
        this.$permissions.havePagePermission('clientes/interesses/idade') ||
        this.$permissions.havePagePermission('clientes/interesses/pessoa_juridica')
      )
    },
    haveMobileOffersTabsPermission() {
      return this.$permissions.havePagePermission('mobile/ofertas/produtos/edicao') || this.$permissions.havePagePermission('mobile/ofertas/destaques')
    },
    haveMobileCashbackTabsPermission() {
      return (
        this.$permissions.havePagePermission('mobile/cashback/cashback') ||
        this.$permissions.havePagePermission('mobile/cashback/controle-de-cpf') ||
        this.$permissions.havePagePermission('mobile/cashback/ajustes') ||
        this.$permissions.havePagePermission('mobile/cashback/bloqueios-de-saldos')
      )
    },
    haveManagementTabsPermission() {
      return (
        this.$permissions.havePagePermission('clientes/gerenciamento/cadastros/visualizar-cadastros') ||
        (this.$permissions.havePagePermission('clientes/gerenciamento/solicitacoes') && this.isFranchise)
      )
    },
    userName() {
      const name = this.$getLoggedUser().name
      return name.split(' ').splice(0, 2).toString().replace(',', ' ')
    },
    clientMenuItems() {
      let items = []

      if (
        this.$permissions.havePagePermission('clientes/consultar-ofertas') &&
        (this.$getAllowedModules()['offer_management'] || this.$getAllowedModules()['industry'])
      ) {
        items.push({
          text: 'Consultar benefícios',
          to: '/clientes/consultar-ofertas',
          dataUserflowId: 'consultar-ofertas',
        })
      }

      if (!this.onlyMercapromo && this.$permissions.havePagePermission('clientes/rfv')) {
        items.push({
          text: 'Classificação RFV',
          to: '/clientes/classificacao-rfv',
          dataUserflowId: 'classificacao-rfv',
        })
      }

      if (!this.onlyMercapromo && this.$permissions.havePagePermission('clientes/segmentacao')) {
        items.push({
          text: 'Segmentação',
          to: '/clientes/segmentacao',
          dataUserflowId: 'segmentacao',
        })
      }

      if (!this.onlyMercapromo && this.$permissions.havePagePermission('clientes/perfil_demografico')) {
        items.push({
          text: 'Perfil Demográfico',
          to: '/clientes/perfil-demografico',
          dataUserflowId: 'perfil-demografico',
        })
      }

      if (!this.onlyMercapromo && this.$permissions.havePagePermission('clientes/mapa')) {
        items.push({
          text: 'Mapa',
          to: '/clientes/mapa',
          dataUserflowId: 'mapa',
        })
      }

      if (!this.onlyMercapromo && this.$permissions.havePagePermission('clientes/retencao')) {
        items.push({
          text: 'Retencão',
          to: '/clientes/retencao',
          dataUserflowId: 'retencao',
        })
      }

      if (!this.onlyMercapromo && !this.$getAllowedModules()['uncategorized_products'] && this.haveInterestTabsPermission && !this.isFranchise) {
        items.push({
          text: 'Interesses',
          to: '/clientes/interesses',
          dataUserflowId: 'interesses',
        })
      }

      if (!this.onlyMercapromo && this.hasPiiAccess && this.$permissions.havePagePermission('clientes/melhores_clientes')) {
        items.push({
          text: 'Melhores Clientes',
          to: '/clientes/melhores-clientes',
          dataUserflowId: 'melhores-clientes',
        })
      }

      if (!this.onlyMercapromo && this.hasPiiAccess && this.$permissions.havePagePermission('clientes/busca_cliente')) {
        items.push({
          text: 'Busca de Cliente',
          to: '/clientes/busca-cliente',
          dataUserflowId: 'busca-cliente',
        })
      }

      if (this.shouldShowGerenciamentoMenuItem) {
        items.push({
          text: 'Gerenciamento de Clientes',
          to: '/clientes/gerenciamento',
          dataUserflowId: 'gerenciamento-clientes',
          showNotification: this.pendingOptoutRequests.showNotification,
          notificationsCounter: this.pendingOptoutRequests.notificationsCounter,
        })
      }

      return items
    },
    showHub() {
      return (
        !this.onlyMercapromo &&
        (this.$permissions.havePagePermission('clientes/rfv') ||
          (this.$permissions.havePagePermission('empresa/faturamento_incremental') && this.$getAllowedModules()['offer_management'])) &&
        this.$permissions.havePagePermission('gerenciador-analises')
      )
    },
    configMenuItems() {
      let items = []

      if (this.$permissions.havePagePermission('configuracoes/lojas')) {
        items.push({
          text: 'Lojas',
          to: '/configuracoes/units',
        })
      }

      if (this.$permissions.havePagePermission('configuracoes/gerais') && !this.isFranchisee) {
        items.push({
          text: 'Gerais',
          to: '/configuracoes/gerais',
          dataUserflowId: 'config',
        })
      }

      if (this.$permissions.havePagePermission('configuracoes/redes-sociais') && !this.isFranchisee) {
        items.push({
          text: 'Redes sociais',
          to: '/configuracoes/redes-sociais',
        })
      }

      if (this.$permissions.havePagePermission('configuracoes/site-cadastramento') && !this.isFranchisee) {
        items.push({
          text: 'Site de cadastramento',
          to: '/configuracoes/site-cadastramento',
        })
      }

      if (this.$permissions.havePagePermission('configuracoes/mensagens')) {
        items.push({
          text: 'Mensagens',
          to: '/configuracoes/mensagens',
        })
      }

      if (this.$permissions.havePagePermission('configuracoes/permissionamento-filiado') && this.isFranchise) {
        items.push({
          text: 'Permissionamento do Filiado',
          to: '/configuracoes/permissionamento-filiado',
        })
      }

      return items
    },
  },
  methods: {
    verifyNewsModule,
    isNew,
    isInMaintenance(route) {
      const accountId = this.$getLoggedUser()?.id_account ?? ''
      const isAccountInMaintenance = this.maintenanceAccountIds.includes('*') || this.maintenanceAccountIds.includes(accountId)
      const isRouteInMaintenance = this.maintenanceModules.includes('*') || this.maintenanceModules.includes(route)

      return isAccountInMaintenance && isRouteInMaintenance
    },
    logout() {
      const singleLoginURL = this.$microservicesUrls['mfLogin']
      const host = location.href.slice(0, location.href.indexOf('#'))
      const hash = window.localStorage.getItem('redirectAfterLogin') || ''

      this.$logout()
      window.location.href = formattedRedirectLogout(singleLoginURL, host, hash)
    },
  },
}
</script>
<style lang="scss">
* {
  font-family: 'Lato', sans-serif;
}
.side-menu {
  z-index: 10;
}

.side-menu-margin-bottom {
  margin-bottom: 32px;
}

.bottom-feedback-box {
  position: absolute;
  background-color: $branco;
  bottom: 0;
  width: 250px;
}

.v-list--nav .v-list-item:not(:last-child):not(:only-child) {
  margin: 0 !important;
}

.v-list-group .v-list-item--active {
  .mf-icon {
    color: $marca-0 !important;
  }
}

.v-application--is-ltr .v-list-group--no-action > .v-list-group__items > .v-list-item {
  padding-left: 52px !important;
}

.v-list-item__icon:not(.v-list-group__header__append-icon) {
  margin-right: 20px !important;
}

@media screen and (max-width: 933px) {
  .side-menu {
    z-index: 7;
    padding-top: 48px;
  }

  .side-menu-margin-bottom {
    margin-bottom: 98px;
  }
}

.userflowjs-beacon {
  pointer-events: none !important;
}

.v-navigation-drawer--mini-variant [data-userflow-id='menu-maria'] {
  opacity: 0 !important;
}
</style>
